import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useEditMode } from '@/contexts/EditModeContext';

const TestimonialCard = ({ testimonial }) => {
  const { isEditMode, sendEditMessage } = useEditMode();
  
  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  const handleEditClick = (e) => {
    if (isEditMode) {
      e.preventDefault();
      e.stopPropagation();
      sendEditMessage('testimonial', testimonial.id, testimonial);
    }
  };

  return (
    <Card 
      className={`p-6 hover:shadow-lg transition-all duration-300 relative group ${isEditMode ? 'cursor-pointer' : ''}`} 
      onClick={handleEditClick}
      data-testid={`testimonial-${testimonial.id}`}
    >
      {isEditMode && (
        <div className="absolute inset-0 border-2 border-dashed border-transparent group-hover:border-blue-500 rounded-lg transition-all duration-200 pointer-events-none z-10">
          <div className="absolute -top-8 left-0 bg-blue-500 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            Edit: {testimonial.name}
          </div>
        </div>
      )}
      <CardContent className="p-0">
        <Quote className="w-10 h-10 text-primary/20 mb-4" />
        
        <p className="text-muted-foreground mb-6 italic leading-relaxed">
          "{testimonial.content}"
        </p>
        
        <div className="flex items-center gap-4">
          <Avatar className="w-12 h-12">
            <AvatarImage src={testimonial.image_url} alt={testimonial.name} />
            <AvatarFallback className="bg-primary/10 text-primary font-medium">
              {getInitials(testimonial.name)}
            </AvatarFallback>
          </Avatar>
          
          <div>
            <h4 className="font-heading font-bold text-foreground">{testimonial.name}</h4>
            <p className="text-sm text-muted-foreground">{testimonial.role}</p>
          </div>
          
          <div className="ml-auto flex gap-1">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className={`w-4 h-4 ${i < testimonial.rating ? 'fill-accent text-accent' : 'text-muted'}`}
              />
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;
